import { render, staticRenderFns } from "./DiscountDetails.vue?vue&type=template&id=544f7dfb&"
import script from "./DiscountDetails.vue?vue&type=script&lang=js&"
export * from "./DiscountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports